/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Length_LabelInputs */



/**
* | output |
* | --- |
* | "Description Length" |
*
* @param {Ad_Description_Length_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_length_label = /** @type {((inputs?: Ad_Description_Length_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Length_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description Longueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibung Länge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione Lunghezza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание Длина")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción Longitud")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("描述长度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("説明の長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विवरण लंबाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição Comprimento")
	return /** @type {LocalizedString} */ ("Description Length")
});